import React from "react";
import { Routes, Route } from "react-router-dom";
import SubPage from "components/pages/graphic/sub-pages";
import type { TGraphicSupplier } from "components/graphic/helpers/graphic-types-helper";
import { PermissionGuard } from 'components/permissions/components/permission-guard';
import { Pages } from 'components/pages';
import GraphicConst from '../../graphic/graphic-const';

interface IGraphicRouteProps
{
    graphic: TGraphicSupplier | undefined;
}

const GraphicRoute: React.FC<IGraphicRouteProps> = ({ graphic }) =>
{
    return (
        <PermissionGuard permission={GraphicConst.permissions.VIEW} fallback={<Pages.Page403 />}>
            <Routes>
                <Route path="/rules" element={<SubPage.Rules graphic={graphic} />} />
                <Route path="/" element={<SubPage.OverView graphic={graphic} />} />
            </Routes>
        </PermissionGuard>
    );
};

export default GraphicRoute;